import {
  useState,
  useCallback,
  useRef,
} from 'react';
import {
  json_admin_users_search_available_admin_users_path as requestPath,
} from 'js-routes/generated/routes';
import debounceFetcher from 'helpers/debounceFetcher';

const useDebounceAdminUserFetch = ({ initialOptions }) => {
  const [searchValue, setSearchValue] = useState('');
  const [dataFetching, setDataFetching] = useState(false);
  const [adminUsers, setAdminUsers] = useState(initialOptions);
  const adminUserFetchRef = useRef(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(debounceFetcher({
    fetchRef: adminUserFetchRef,
    setOptions: setAdminUsers,
    setFetching: setDataFetching,
    requestPath,
  }), []);

  const debouncedAdminUsersFetch = (searchText) => {
    setSearchValue(searchText);
    debouncedSearch(searchText);
  };

  return ({
    adminUserFetch: debouncedAdminUsersFetch,
    searchValue,
    dataFetching,
    adminUsers,
  });
};

export default useDebounceAdminUserFetch;
